import React, { useEffect } from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useTranslation  } from 'hooks';

import { translations } from './translations';

import {
  PaginateAlertEmailLogsState,
} from 'store/ducks/settings/alert-email-logs';

import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridAlertEmailLogs, FilterAlertEmailLogs } from 'components/settings';
import * as S from './styles';
import { useFilters } from 'hooks/useFilters';

export const ListAlertEmailLogs: React.FC = () => {
  const { getTranslation } = useTranslation(translations);
  const { getData } = useFilters('alertEmailLogs');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateAlertEmailLogs
  ) as PaginateAlertEmailLogsState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page='alert-email-logs' />
          {loading && <S.LoadingPage />}
        </h1>

        <S.HeaderButtons>
          <FilterAlertEmailLogs />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridAlertEmailLogs alertEmailLogs={data} />
        <Paginator
          pagination={pagination}
          settingsPage='alertEmailLogs'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
